module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tooltip">\n    <div class="tooltip-arrow"></div>\n    <div class="tooltip-inner"></div>\n</div>\n';
}
return __p;
};
